import { BehaviorSubject, Subscription } from 'rxjs';
import { UploadState } from '../enums/upload-state.enum';

export interface FileInfo {
  id?: any;
  name: string;
  size: number;
}

export class UploadFile {
  constructor(
    public fileInfo: FileInfo,
    public progress: BehaviorSubject<number> = new BehaviorSubject<number>(0),
    public state: BehaviorSubject<UploadState> = new BehaviorSubject<UploadState>(
      UploadState.uploading
      ),
    public requestSubsciption?: Subscription,
  ) {}
}
